<template>
    <div  @click="backTop"  class="backTop" v-show="showgo">
        <img src="../assets/icons/回顶部.svg" alt="">
    </div>
</template>
<script>
// import { reactive, toRefs } from '@vue/reactivity'
// import { onBeforeUnmount, onMounted } from 'vue-demi'
   export default {
    name : "backTop",
    props:{
        top:{
            Number
        }
    },
    data(){
        return{
            showgo:false,
            add:300,
        }
    },
    created(){
        // this.setTime() // 延时1.5秒调用方法，等待父组件的传参返回
    },
    mounted(){
    // var vm = this;
    // window.onscroll = function () {
    //   if (document.documentElement.scrollTop >  300) {
    //     vm.showgo = true;
    //   } else {
    //     vm.showgo = false;
    //   }
    // };
    window.addEventListener('scroll', this.handleScroll)
    },
    methods:{
    //     setTime(){ // 定时器，延时调用方法
    //       let win = this
    //       setTimeout(function(){
    //           console.log(win.top); // 获取数据
    //           win.add = win.top
    //       },1500)  
    //     },
    //     backTop() {
    //   scrollTo(0, 0);
    //     this.showgo=false

    // },
          handleScroll (){
            if (window.scrollY > 400 ) {
         this.showgo = true
            } else {
              this.showgo = false
            }
          },
            backTop(){
               scrollTo(0, 0);
                this.showgo=false
            }
    }
   }
</script>
<style lang="scss" >
.backTop {
 width: 49px;
height: 49px;
background: rgba(25, 196, 250, 0.8);
opacity: 0.8;
  position: fixed;
  bottom: 70px;
  right: 20px;
  background-color: #FFF;
  border-radius: 50%;
  z-index: 999;
  img {
    width: 49px;
    height: 49px;
  }
}
</style>

